(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-variant-picker"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-rp-size-guide-open]');
    if (!trigger) return;
    const dialog = document.getElementById(trigger.getAttribute('aria-controls'));
    const chart = document.getElementById('sizechart');
    if (!dialog || !chart || typeof dialog.showModal !== 'function') return;
    event.preventDefault();
    const copy = chart.cloneNode(true);
    copy.removeAttribute('id');
    if (document.documentElement.lang.toLowerCase().startsWith('es')) {
      const headings = ['Talla', 'Largo', 'Ancho', 'Largo de manga'];
      copy.querySelectorAll('th').forEach((cell, index) => {
        if (headings[index]) cell.textContent = headings[index];
      });
    }
    dialog.querySelector('[data-rp-size-guide-content]').replaceChildren(copy);
    dialog.showModal();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rp-size-guide"] && !Shopify.designMode) return;
  try {
    document.addEventListener('toggle', (event) => {
    if (!event.target.matches('.rp-sizing__details') || !event.target.open) return;
    event.target.querySelector('.rp-sizing__units').hidden = false;
  }, true);
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-rp-unit]');
    if (!button) return;
    const guide = button.closest('[data-rp-sizing]');
    const unit = button.dataset.rpUnit;
    guide.querySelectorAll('[data-rp-inches]').forEach((cell) => {
      const inches = Number(cell.dataset.rpInches);
      cell.textContent = unit === 'cm' ? (inches * 2.54).toFixed(1) : cell.dataset.rpInches;
    });
    guide.querySelectorAll('[data-rp-unit]').forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
    const label = guide.querySelector('[data-rp-unit-label]');
    label.textContent = label.dataset[unit];
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["rp-video-feed-runtime"] && !Shopify.designMode) return;
  try {
    (() => {
    function mount(root, options = {}) {
      if (!root || root.dataset.ready === 'true') return root?._rpVideoFeed;
      root.dataset.ready = 'true';
      const modal = Boolean(options.modal);
      root.classList.toggle('rp-video-feed--modal', modal);
      const events = new AbortController();
      const listen = (target, type, handler, settings = {}) => target.addEventListener(type, handler, { ...settings, signal: events.signal });
      const pageUrl = options.pageUrl || window.location.href;
      const scroller = root.querySelector('[data-feed-scroller]');
      const slides = [...root.querySelectorAll('[data-feed-slide]')];
      const counter = root.querySelector('[data-feed-counter]');
      const toast = root.querySelector('[data-feed-toast]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const saveData = navigator.connection && navigator.connection.saveData;
      let active = -1;
      let soundOn = false;
      let scrollTick = false;
      let scrollFrame;
      let toastTimer;

      const pad = number => String(number).padStart(2, '0');
      const videoAt = index => slides[index]?.querySelector('[data-feed-video]');

      function loadNear(index) {
        slides.forEach((slide, slideIndex) => {
          const video = videoAt(slideIndex);
          if (Math.abs(slideIndex - index) <= 1 && video.dataset.src && !video.src) {
            video.src = (window.innerWidth <= 700 || saveData) && video.dataset.srcMobile ? video.dataset.srcMobile : video.dataset.src;
            video.preload = slideIndex === index ? 'auto' : 'metadata';
            video.load();
          } else if (Math.abs(slideIndex - index) > 1 && video.src) {
            video.pause();
            video.removeAttribute('src');
            video.load();
          }
        });
      }

      function syncButtons(index) {
        const slide = slides[index];
        const video = videoAt(index);
        if (!slide || !video) return;
        slide.dataset.paused = String(video.paused);
        slide.dataset.muted = String(video.muted);
        slide.querySelector('[data-feed-play]').setAttribute('aria-label', video.paused ? root.dataset.playLabel : root.dataset.pauseLabel);
        const soundButton = slide.querySelector('[data-feed-sound]');
        soundButton.setAttribute('aria-label', video.muted ? root.dataset.soundOnLabel : root.dataset.soundOffLabel);
        soundButton.setAttribute('aria-pressed', String(!video.muted));
      }

      function playCurrent() {
        const video = videoAt(active);
        if (!video || !video.src || reducedMotion || saveData || document.hidden) return;
        video.muted = !soundOn;
        video.play().catch(() => syncButtons(active));
        syncButtons(active);
      }

      function setActive(index) {
        if (index < 0 || index >= slides.length || index === active) return;
        if (active >= 0) videoAt(active).pause();
        active = index;
        loadNear(index);
        slides.forEach((slide, slideIndex) => slide.dataset.active = String(slideIndex === index));
        counter.textContent = pad(index + 1);
        const url = new URL(pageUrl);
        url.searchParams.set('clip', slides[index].dataset.clip);
        if (!modal) history.replaceState(history.state, '', url);
        const video = videoAt(index);
        video.muted = !soundOn;
        syncButtons(index);
        playCurrent();
      }

      function nearestSlide() {
        const index = Math.round(scroller.scrollTop / scroller.clientHeight);
        setActive(Math.max(0, Math.min(slides.length - 1, index)));
      }

      function goTo(index) {
        if (index < 0 || index >= slides.length) return;
        scroller.scrollTo({ top: slides[index].offsetTop, behavior: reducedMotion ? 'auto' : 'smooth' });
      }

      function showToast(message) {
        toast.textContent = message;
        toast.dataset.visible = 'true';
        clearTimeout(toastTimer);
        toastTimer = setTimeout(() => { toast.dataset.visible = 'false'; }, 2400);
      }

      slides.forEach((slide, index) => {
        const video = videoAt(index);
        slide.dataset.paused = 'true';
        slide.dataset.muted = 'true';
        listen(video, 'play', () => syncButtons(index));
        listen(video, 'pause', () => syncButtons(index));
        listen(video, 'timeupdate', () => {
          const progress = slide.querySelector('[data-feed-progress]');
          progress.style.width = video.duration ? `${video.currentTime / video.duration * 100}%` : '0';
        });
        listen(video, 'click', () => slide.querySelector('[data-feed-play]').click());
        listen(slide.querySelector('[data-feed-play]'), 'click', () => {
          if (video.paused) video.play().catch(() => syncButtons(index));
          else video.pause();
          syncButtons(index);
        });
        listen(slide.querySelector('[data-feed-sound]'), 'click', () => {
          soundOn = video.muted;
          video.muted = !soundOn;
          if (video.paused) video.play().catch(() => syncButtons(index));
          syncButtons(index);
        });
        listen(slide.querySelector('[data-feed-share]'), 'click', async () => {
          const url = new URL(pageUrl);
          url.searchParams.set('clip', slide.dataset.clip);
          url.searchParams.delete('embed');
          if (navigator.share) {
            try { await navigator.share({ title: slide.querySelector('h2').textContent, url: url.href }); return; }
            catch (error) { if (error.name === 'AbortError') return; }
          }
          try { await navigator.clipboard.writeText(url.href); showToast(root.dataset.copiedLabel); }
          catch (error) { showToast(url.href); }
        });
      });

      listen(scroller, 'scroll', () => {
        if (scrollTick) return;
        scrollTick = true;
        scrollFrame = requestAnimationFrame(() => { nearestSlide(); scrollTick = false; });
      }, { passive: true });

      listen(document, 'keydown', event => {
        if (modal && event.key === 'Escape') {
          event.preventDefault();
          options.onClose?.();
          return;
        }
        if (/^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName || '')) return;
        if (event.key === ' ' && document.activeElement?.closest('button, a')) return;
        if (event.key === 'ArrowDown' || event.key === 'PageDown' || event.key.toLowerCase() === 'j') { event.preventDefault(); goTo(active + 1); }
        if (event.key === 'ArrowUp' || event.key === 'PageUp' || event.key.toLowerCase() === 'k') { event.preventDefault(); goTo(active - 1); }
        if (event.key.toLowerCase() === 'm') { slides[active]?.querySelector('[data-feed-sound]')?.click(); }
        if (event.key === ' ') { event.preventDefault(); slides[active]?.querySelector('[data-feed-play]')?.click(); }
      });
      listen(document, 'visibilitychange', () => { if (document.hidden) videoAt(active)?.pause(); else playCurrent(); });

      const requested = new URL(pageUrl).searchParams.get('clip');
      const requestedIndex = slides.findIndex(slide => slide.dataset.clip === requested);
      if (requestedIndex > 0) scroller.scrollTop = slides[requestedIndex].offsetTop;
      setActive(Math.max(0, requestedIndex));
      const handle = {
        destroy() {
          events.abort();
          clearTimeout(toastTimer);
          cancelAnimationFrame(scrollFrame);
          slides.forEach((slide, index) => {
            const video = videoAt(index);
            video.pause();
            video.removeAttribute('src');
            video.load();
          });
          root.dataset.ready = 'false';
          delete root._rpVideoFeed;
        }
      };
      root._rpVideoFeed = handle;
      return handle;
    }
    window.RicanPrideStories = { mount };
    document.querySelectorAll('.rp-video-feed').forEach(root => mount(root));
  })();
  } catch(e) { console.error(e); }
})();

})();
